import { render, staticRenderFns } from "./DokumenKontrak.vue?vue&type=template&id=6a2a49ea"
import script from "./DokumenKontrak.vue?vue&type=script&lang=js"
export * from "./DokumenKontrak.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports